import Footer from 'components/modules/landing/alternate/Footer';
import DefaultLandingNavbar from 'components/navbars/default-landing-navbar/DefaultLandingNavbar';
import { Card, Row } from 'react-bootstrap';
const TermsOfService = () => {
  return (
    <>
      <div className="bg-body-emphasis dark__bg-gray-1200">
        <DefaultLandingNavbar className="dark__bg-gray-1200" />
        <div className="container">
          <Row className="flex-center min-vh-100 py-5">
            <h2 className="text-center py-5">Terms Of Service</h2>

            <Card>
              <Card.Body>
                <Card.Title>Effective Date: 01/01/2025 </Card.Title>
                <Card.Title>Last updated Date: 14/08/2025 </Card.Title>
                <Card.Text>
                  <p>
                    Welcome to MLAS (ملّاس) — Kuwait’s first culturally rooted
                    AI-powered nutrition and dietary logging system. These Terms
                    of Service (“Terms”) govern your use of MLAS. By using our
                    platform, you agree to these Terms.
                  </p>
                  <ol>
                    <li>
                      <h5>About MLAS:</h5>
                      <ul>
                        <li>
                          MLAS provides a digital nutrition-tracking platform
                          that connects clients with licensed dietitians. Our
                          goal is to make food logging more accurate, culturally
                          relevant, and data-driven.
                        </li>
                      </ul>
                    </li>
                    <li>
                      <h5>Who Can Use MLAS:</h5>
                      <p>You must: </p>
                      <ul>
                        <li>
                          Be 18 years or older, or have parental consent if
                          under 18.
                        </li>
                        <li>
                          Register under the supervision of a licensed dietitian
                          or healthcare provider.
                        </li>
                        <li>
                          Provide accurate information during registration.
                        </li>
                      </ul>
                      <p>
                        MLAS may suspend or terminate accounts that violate
                        these Terms.{' '}
                      </p>
                    </li>
                    <li>
                      <h5>Subscriptions and Payments:</h5>
                      <ul>
                        <li>MLAS operates on an annual subscription basis.</li>
                        <li>
                          Subscriptions auto-renew unless canceled before
                          renewal.
                        </li>
                        <li>
                          Payments are non-refundable except as required by law.
                        </li>
                        <li>
                          Pricing and terms may change with prior notice.{' '}
                        </li>
                      </ul>
                    </li>
                    <li>
                      <h5>How MLAS Works:</h5>
                      <ul>
                        <li>
                          Users can upload meal images and log food using the{' '}
                          <strong>USDA Food Database.</strong>
                        </li>
                        <li>
                          MLAS calculates macronutrients and sends summaries to
                          assigned dietitians.{' '}
                        </li>
                        <li>
                          In <strong>March 2026,</strong> MLAS will introduce{' '}
                          <strong>AI-powered food recognition</strong> to
                          automate this process.
                        </li>
                        <li>
                          MLAS provides nutrition tracking tools but does{' '}
                          <strong>
                            {' '}
                            not replace professional medical advice.
                          </strong>
                        </li>
                      </ul>
                    </li>
                    <li>
                      <h5>User Responsibilities:</h5>
                      <p>You agree to: </p>
                      <ul>
                        <li>
                          Use MLAS for personal or clinical nutrition purposes
                          only.{' '}
                        </li>
                        <li>
                          Not misuse, copy, or reverse-engineer the software.{' '}
                        </li>
                        <li>Keep your account credentials secure. </li>
                        <li>
                          Respect the privacy of other users and professionals.{' '}
                        </li>
                      </ul>
                    </li>
                    <li>
                      <h5>Data Privacy and Security:</h5>
                      <p>
                        MLAS protects your information under{' '}
                        <strong>HIPAA</strong> and{' '}
                        <strong>
                          Kuwait’s Personal Data Protection Law (PDPL).
                        </strong>
                      </p>
                      <ul>
                        <li>All personal and image data is encrypted. </li>
                        <li>
                          Your identifiable information is never sold or shared
                          with third parties.{' '}
                        </li>
                        <li>
                          You may request deletion of your data at any time by
                          contacting MLAS Support.
                        </li>
                      </ul>
                    </li>
                    <li>
                      <h5>Use of Data for Research and Development:</h5>
                      <p>By using MLAS, you agree that: </p>
                      <ul>
                        <li>
                          MLAS may collect, combine, and analyze{' '}
                          <strong>anonymized and aggregated data</strong>{' '}
                          (metrics, usage trends, and food logs) to improve our
                          services and AI models.
                        </li>
                        <li>
                          These anonymized datasets may be used for{' '}
                          <strong>
                            scientific research, product improvement, and
                            publication in academic journals or conferences
                          </strong>
                        </li>
                        <li>
                          No personally identifiable information (PII) will ever
                          be shared, disclosed, or published.
                        </li>
                        <li>
                          All research use complies with ethical and legal
                          standards for data protection and privacy.
                        </li>
                      </ul>
                    </li>
                    <li>
                      <h5>Communication and Professional Use:</h5>
                      <p>
                        Dietitians using MLAS may view client data and
                        communicate within the app. All communication and data
                        sharing are confidential and compliant with privacy
                        regulations.{' '}
                      </p>
                    </li>
                    <li>
                      <h5>Intellectual Property:</h5>
                      <p>
                        All MLAS content, algorithms, and designs are protected
                        intellectual property of MLAS. Users may not reproduce,
                        resell, or distribute any part of the platform without
                        written consent.
                      </p>
                    </li>
                    <li>
                      <h5>AI Disclaimer:</h5>
                      <p>
                        When launched, the AI camera will provide automated food
                        detection. Results are estimates and should be confirmed
                        by a qualified dietitian. MLAS is not liable for
                        clinical or medical outcomes based solely on AI
                        analysis.{' '}
                      </p>
                    </li>
                    <li>
                      <h5>Limitation of Liability:</h5>
                      <p>
                        MLAS is provided “as is.” We are not liable for indirect
                        losses, data errors, or health outcomes resulting from
                        misuse. Users are responsible for their own health
                        decisions.{' '}
                      </p>
                    </li>
                    <li>
                      <h5>Termination:</h5>
                      <p>
                        We may suspend or close accounts that violate these
                        Terms. Users may cancel subscriptions anytime; access
                        remains active until the end of the paid period.{' '}
                      </p>
                    </li>
                    <li>
                      <h5>Acceptance of Terms:</h5>
                      <p>
                        By using this app, you agree to comply with these Terms
                        and Conditions and all applicable laws.{' '}
                      </p>
                    </li>
                    <li>
                      <h5>User Responsibility:</h5>
                      <p>
                        As a dietitian, you must ensure that any feature enabled
                        is appropriate for your patient. You are responsible for
                        monitoring your patient's mental and physical health,
                        particularly concerning eating disorders.{' '}
                      </p>
                    </li>
                    <li>
                      <h5>AI Functionality:</h5>
                      <p>
                        The AI-generated nutritional information provided is
                        designed to support healthy eating habits. However, it
                        is not a substitute for professional medical advice or
                        treatment.{' '}
                      </p>
                    </li>
                    <li>
                      <h5>Patient Safety:</h5>
                      <p>
                        Always prioritize your patient’s safety and well-being,
                        and assess the suitability of any tool or feature for
                        each individual patient.{' '}
                      </p>
                    </li>
                    <li>
                      <h5>Modification of Terms:</h5>
                      <p>
                        We reserve the right to modify these Terms and
                        Conditions at any time. Continued use of the app
                        signifies your acceptance of any revised terms.{' '}
                      </p>
                    </li>
                    <li>
                      <h5>Liability:</h5>
                      <p>
                        The app's creators are not liable for any outcomes
                        resulting from the use of the features enabled within
                        the app.{' '}
                      </p>
                    </li>
                    <li>
                      <h5>Contact:</h5>
                      <p>
                        Email:{' '}
                        <a href="emailto:mlas.kuwait@gmail.com">
                          mlas.kuwait@gmail.com
                        </a>
                      </p>
                      <p>
                        Website URL:{' '}
                        <a href="https://mlasmena.com/">mlasmena.com</a>
                      </p>
                    </li>
                    <li>
                      <h5>MLAS — Tradition Meets Technology:</h5>
                      <p>
                        By using MLAS, you support data-driven innovation in
                        nutrition and contribute to advancing research that
                        benefits public health in Kuwait and beyond.
                      </p>
                    </li>
                  </ol>
                </Card.Text>
              </Card.Body>
            </Card>
          </Row>
        </div>

        <Footer />
      </div>
    </>
  );
};

export default TermsOfService;
